import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { gold } from '../getLPTheme';
import CircularProgress from '@mui/material/CircularProgress';
import { createTheme, ThemeProvider } from '@mui/material/styles';

// Augment the palette to include an brand color
declare module '@mui/material/styles' {
    interface Palette {
      brand: Palette['primary'];
    }
  
    interface PaletteOptions {
      brand?: PaletteOptions['primary'];
    }
  }


// Update the CircularProgress's color options to include an ochre option
declare module '@mui/material/CircularProgress' {
    interface CircularProgressPropsColorOverrides {
      brand: true;
    }
  }

const theme = createTheme({
    palette: {
      brand: {
        main: gold[500],
        light: gold[100],
        dark: gold[900],
        contrastText: gold[200],
      },
    },
  });


const Loading = () => {
    return (
        <ThemeProvider theme={theme}>
            <Box>
                <Box>
                    <Box>
                        <Box sx={{width:"100%", display: "flex", justifyContent:"center", alignItems:"center"}}>
                            <CircularProgress color="brand"/>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </ThemeProvider>
    )
}

export default Loading;